import React, { useEffect, useState } from "react";
import { ButtonGroup, Col, Form, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";

import SelectCustom from "components/Common/SelectCustom";
import { getBrochure, getReportProperties, getTypeProperties } from "store/actions";
import { getAreas } from "../../store/Config/actions";

const FormBrochure = (props) => {

    const dispatch = useDispatch();
    const { typeProperties, areas } = useSelector(state => ({
        typeProperties: state.TypePropertyReducer.typeProperties,
        areas: state.ConfigInit.areas,
    }));
    const [areasList, setAreasList] = useState([]);

    useEffect(() => {
        dispatch(getTypeProperties({ active: true, typePropertyParent: null, typePropertyLevel: 1 }));
        dispatch(getAreas({ for_: 'inventory', active: true }));
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            area: "",
        },
        validationSchema: Yup.object({
            area: Yup.string().required("Selecciona el area para generar el Brochure"),
        }),
        onSubmit: (values) => {
            const report = {
                area_id: values["area"],
            };
            dispatch(getBrochure(report));
        }
    });

    useEffect(() => {
        let areasL = [...areas];
        areasL.unshift({ id: 'all', name: "Todas las áreas" });
        setAreasList(areasL);
    }, [areas]);


    return (
        <>
            <Form onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
            }}>
                <Row>
                    <Col className="col-6">
                        <ButtonGroup>
                            <SelectCustom
                                lblInput="Selecciona el area para generar el Brochure"
                                inputName="area"
                                inputPlaceholder="Elige el area"
                                validation={validation}
                                data={areasList}
                            />
                        </ButtonGroup>
                    </Col>
                    <Col className="col-6">
                        <Label className="form-label">&nbsp;</Label>
                        <div className="">
                            <button
                                type="submit"
                                className="btn btn-success save-schedule"
                            >
                                Enviar
                            </button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default FormBrochure